/* Reveal bands as they enter the viewport.
 *
 * Decoration only: it encodes no quantity, so it cannot be mistaken for data
 * (14_BRAND_SYSTEM design principle P3). Anyone who has asked their system for
 * reduced motion gets the finished state immediately and no observer is
 * created at all.
 *
 * If IntersectionObserver is missing, every band is shown rather than hidden.
 * Content must never depend on a script to become visible.
 */
(function () {
  'use strict';

  function showAll() {
    var nodes = document.querySelectorAll('.dc-rise');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('in');
    // Drop the flag too, so the hidden rule stops applying entirely.
    document.documentElement.classList.remove('dc-motion');
  }

  // Last resort. If anything at all goes wrong between here and the observer
  // firing, the page reveals itself rather than staying blank.
  var failsafe = window.setTimeout(showAll, 3000);

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduced || !('IntersectionObserver' in window)) {
    showAll();
    return;
  }

  function start() {
    try {
      run();
    } catch (e) {
      showAll();
    }
  }

  function run() {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        });
      },
      // Reveal EARLY and on any intersection at all.
      //
      // This used to be `-12%` with a 0.08 threshold, which required a band to
      // be meaningfully inside a SHRUNK viewport before it appeared. Bands run
      // ~800px against a ~950px viewport, so scrolling in jumps (a scrollbar
      // drag, PageDown, a trackpad flick) could land on a band that had not
      // triggered yet and the screen was blank paper. Expanding the root
      // instead means a band is always already visible by the time it reaches
      // the viewport, so nothing can be read as an empty page.
      { rootMargin: '400px 0px 400px 0px', threshold: 0 }
    );

    var nodes = document.querySelectorAll('.dc-rise');
    for (var i = 0; i < nodes.length; i++) {
      // Anything already on screen at load is shown without waiting.
      var r = nodes[i].getBoundingClientRect();
      // Anything on screen at load, or within a screen of it, is shown at once.
      if (r.top < window.innerHeight * 2) nodes[i].classList.add('in');
      else observer.observe(nodes[i]);
    }
    window.clearTimeout(failsafe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Mobile buy bar: shown only while no add-to-cart form is on screen. At the
   top of the page the main button is right there, so the bar would only
   cover copy; it appears once the buyer has scrolled past a buy button and
   disappears again when the next one comes into view. */
(function () {
  'use strict';
  var bar = document.querySelector('[data-dc-stickybar]');
  if (!bar || !('IntersectionObserver' in window)) return;
  var forms = Array.prototype.filter.call(
    document.querySelectorAll('form[action*="/cart/add"]'),
    function (f) { return !bar.contains(f); }
  );
  if (!forms.length) return;
  var visible = 0;
  var seen = new WeakMap();
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var was = seen.get(e.target) || false;
      if (e.isIntersecting && !was) visible++;
      if (!e.isIntersecting && was) visible--;
      seen.set(e.target, e.isIntersecting);
    });
    bar.classList.toggle('is-visible', visible <= 0 && window.scrollY > 200);
  }, { threshold: 0 });
  forms.forEach(function (f) { io.observe(f); });
  window.addEventListener('scroll', function () {
    if (window.scrollY <= 200) bar.classList.remove('is-visible');
    else if (visible <= 0) bar.classList.add('is-visible');
  }, { passive: true });
})();
